/*
 * Openingstijden – herbruikbare open/dicht-logica
 *
 * De berekening gebeurt bewust in de browser: Shopify cachet pagina's,
 * dus Liquid's `now` is niet betrouwbaar voor "nu open?".
 *
 * Openingstijden.status(data, { timezone, wall })
 *   data = output van snippets/mublio-openingstijden-data.liquid
 *   wall = optioneel gesimuleerd tijdstip { y, m, d, min } (min = minuten na middernacht),
 *          bijv. voor de voorbeeldweergave in de theme editor
 *   →  { open: true,  sluitOm: '17:00', contactpersoon }
 *   →  { open: false, moment: 'morgenochtend', dag: 'morgen', tijd: '09:00', feestdag: '', contactpersoon }
 *   →  { open: false, moment: 'na de Kerstdagen', feestdag: 'de Kerstdagen', ... }  (gesloten door feestdag)
 *   →  { open: false, moment: '', ... }  (geen opening gevonden in 14 dagen)
 *
 * Openingstijden.format(template, status)
 *   vervangt [naam], [moment], [dag], [tijd], [sluit], [feestdag] in een tekst.
 *
 * Openingstijden.wallNow(tz) / Openingstijden.addDays(wall, n)
 *   hulpjes om een (gesimuleerd) lokaal tijdstip te maken.
 */
(function () {
  if (window.Openingstijden) return;

  var DEFAULT_TZ = 'Europe/Amsterdam';
  var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var DAG_MS = 864e5;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }

  function wallNow(tz) {
    var o = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: tz || DEFAULT_TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, min: (+o.hour % 24) * 60 + (+o.minute) };
  }

  function addDays(w, n) {
    var dt = new Date(Date.UTC(w.y, w.m - 1, w.d) + n * DAG_MS);
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(), min: w.min };
  }

  /* Pasen (Gregoriaans, anonieme methode) → Date (UTC-middernacht) */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }

  /* Naam van een Nederlandse feestdag zoals hij in "na …" leest, of '' */
  var feestCache = {};
  function feestdagen(y) {
    if (feestCache[y]) return feestCache[y];
    var map = {};
    function add(t, naam) { var dt = new Date(t); map[dt.toISOString().slice(0, 10)] = naam; }
    var p = easter(y);
    add(Date.UTC(y, 0, 1), 'Nieuwjaarsdag');
    add(p - 2 * DAG_MS, 'Pasen');            // Goede Vrijdag (als jullie dan dicht zijn)
    add(p, 'Pasen');
    add(p + DAG_MS, 'Pasen');
    var kd = Date.UTC(y, 3, 27);
    if (new Date(kd).getUTCDay() === 0) kd -= DAG_MS; // Koningsdag op zondag → zaterdag 26e
    add(kd, 'Koningsdag');
    add(Date.UTC(y, 4, 5), 'Bevrijdingsdag');
    add(p + 39 * DAG_MS, 'Hemelvaartsdag');
    add(p + 49 * DAG_MS, 'Pinksteren');
    add(p + 50 * DAG_MS, 'Pinksteren');
    add(Date.UTC(y, 11, 24), 'de Kerstdagen');
    add(Date.UTC(y, 11, 25), 'de Kerstdagen');
    add(Date.UTC(y, 11, 26), 'de Kerstdagen');
    add(Date.UTC(y, 11, 31), 'de jaarwisseling');
    return (feestCache[y] = map);
  }
  function feestdagNaam(iso) { return feestdagen(+iso.slice(0, 4))[iso] || ''; }

  function toMin(t) {
    if (!t || t.indexOf(':') < 0) return null;
    var a = t.split(':');
    return (+a[0]) * 60 + (+a[1]);
  }

  function dagdeel(min) {
    if (min < 12 * 60) return 'ochtend';
    if (min < 18 * 60) return 'middag';
    return 'avond';
  }

  function status(data, opts) {
    data = data || {};
    opts = opts || {};
    var n = opts.wall || wallNow(opts.timezone);
    var base = Date.UTC(n.y, n.m - 1, n.d);
    var gesloten = data.gesloten || [];
    var dagen = data.dagen || [];
    var naam = data.contactpersoon || '';
    var feestdag = '';   // laatste feestdag die we overslaan op weg naar de volgende opening

    for (var i = 0; i < 14; i++) {
      var dt = new Date(base + i * DAG_MS);
      var iso = dt.toISOString().slice(0, 10);
      var wd = dt.getUTCDay();

      if (gesloten.indexOf(iso) > -1) {
        feestdag = feestdagNaam(iso) || feestdag || 'de feestdagen';
        continue;
      }

      var dag = dagen[wd];
      var o = dag && toMin(dag.open);
      var s = dag && toMin(dag.sluit);
      if (o == null || s == null || s <= o) continue;

      if (i === 0) {
        if (n.min >= o && n.min < s) {
          return { open: true, sluitOm: dag.sluit, contactpersoon: naam };
        }
        if (n.min >= s) continue; // vandaag al dicht
      }

      var deel = dagdeel(o);
      var dagLabel = i === 0 ? 'vandaag' : i === 1 ? 'morgen' : DAGEN[wd];
      var moment = feestdag
        ? 'na ' + feestdag
        : (i === 0 ? 'van' + deel : (i === 1 ? 'morgen' : DAGEN[wd]) + deel);
      return { open: false, moment: moment, dag: dagLabel, tijd: dag.open, feestdag: feestdag, contactpersoon: naam };
    }
    return { open: false, moment: '', dag: '', tijd: '', feestdag: feestdag, contactpersoon: naam };
  }

  function format(tpl, st) {
    return String(tpl || '')
      .replace(/\[naam\]/g, st.contactpersoon || '')
      .replace(/\[moment\]/g, st.moment || '')
      .replace(/\[dag\]/g, st.dag || '')
      .replace(/\[tijd\]/g, st.tijd || '')
      .replace(/\[sluit\]/g, st.sluitOm || '')
      .replace(/\[feestdag\]/g, st.feestdag || '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  window.Openingstijden = { status: status, format: format, wallNow: wallNow, addDays: addDays, feestdagNaam: feestdagNaam };
})();
